import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import { UserService } from 'shared/services/User/user.service';
import { Headers, Http } from '@angular/http';

@Injectable()
export class SsOnboardingService {

  constructor(
    private userService: UserService,
    private http: Http
  ) { }

  connectTeamAccount(data, team_id) {
    const headers = new Headers();
    headers.append('token', this.userService.user.token);
    const userParams = new FormData();
    userParams.append('account_email',  data.email);
    userParams.append('password', data.password);
    userParams.append('team_id', team_id);
    return this.http.post(environment.API_BASE_URL + '/auth/connectTeamAccount', userParams, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        console.log(err);
        return Observable.throw(err.json());
      });
  }

  loginTicketmaster(data, team_id) {
    const headers = new Headers();
    headers.append('token', this.userService.user.token);
    const request: any = {};
    request.account_id = data.email;
    request.pin = data.password;
    request.team_id = team_id;
    return this.http.post(environment.API_BASE_URL + '/vendors/ticketmaster/auth', request, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        return Observable.throw(err.json());
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/SS-Onboard/ss-onboarding.service.ts